export const actors = [
  {
    id: "lin-zhi-yao",
    name: "林知遥",
    avatar:
      "https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20elegant%20young%20chinese%20actress%20with%20calm%20confident%20expression%2C%20soft%20neutral%20grey%20background%2C%20cinematic%20soft%20lighting%2C%20clean%20editorial%20photography%20style%2C%20highly%20detailed%2C%20no%20text&width=500&height=500&seq=actor-linzhiyao&orientation=squarish",
    bio: "林知遥，毕业于中央戏剧学院表演系，以细腻内敛的表演风格受到关注。早期在话剧舞台打磨演技，后凭悬疑剧《暮色回声》中法医苏黎一角被更多观众熟知。她擅长塑造冷静而有层次感的女性角色，被媒体称为“最会演沉默的演员”之一。",
    birthday: "1995-04-12",
    birthPlace: "江苏南京",
    tags: ["实力派", "悬疑题材常客", "话剧出身"],
    works: [
      { dramaId: "mu-se-hui-sheng", title: "暮色回声", role: "饰 苏黎（法医）", year: 2024 },
      { dramaId: "shan-hai-huan-meng-lu", title: "山海幻梦录", role: "饰 云绾", year: 2024 },
      { dramaId: "mi-wu-dang-an", title: "迷雾档案", role: "饰 温青", year: 2023 },
    ],
  },
  {
    id: "shen-yi-zhou",
    name: "沈亦舟",
    avatar:
      "https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20handsome%20young%20chinese%20actor%20with%20serious%20thoughtful%20look%2C%20soft%20neutral%20grey%20background%2C%20cinematic%20soft%20lighting%2C%20clean%20editorial%20photography%20style%2C%20highly%20detailed%2C%20no%20text&width=500&height=500&seq=actor-shenyizhou&orientation=squarish",
    bio: "沈亦舟，1993 年生，演员。以刑侦、悬疑题材见长，塑造过刑警队长、取证专家等多个硬朗而复杂的角色。表演张力强、眼神戏出色，是近年悬疑剧体系中极具辨识度的一张面孔。",
    birthday: "1993-09-27",
    birthPlace: "辽宁大连",
    tags: ["悬疑男神", "眼神戏", "刑侦专业户"],
    works: [
      { dramaId: "mu-se-hui-sheng", title: "暮色回声", role: "饰 江砚（刑警队长）", year: 2024 },
      { dramaId: "wu-sheng-zhi-cheng", title: "无声之城", role: "饰 韩默", year: 2024 },
      { dramaId: "mi-wu-dang-an", title: "迷雾档案", role: "饰 秦戈", year: 2023 },
    ],
  },
  {
    id: "su-wan-ning",
    name: "苏晚凝",
    avatar:
      "https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20warm%20gentle%20young%20chinese%20actress%20with%20soft%20smile%2C%20soft%20neutral%20beige%20background%2C%20cinematic%20soft%20lighting%2C%20clean%20editorial%20photography%20style%2C%20highly%20detailed%2C%20no%20text&width=500&height=500&seq=actor-suwanning&orientation=squarish",
    bio: "苏晚凝，演员，擅长年代剧与现实主义题材。她在《云上归途》中饰演坚韧的何知秋，凭此角色获得年度新人提名。表演自然、共情力强，被观众称为“一眼就让人相信的角色脸”。",
    birthday: "1996-06-18",
    birthPlace: "四川成都",
    tags: ["年代剧", "共情力强", "新人提名"],
    works: [
      { dramaId: "yun-shang-gui-tu", title: "云上归途", role: "饰 何知秋", year: 2023 },
      { dramaId: "wu-sheng-zhi-cheng", title: "无声之城", role: "饰 林霁", year: 2024 },
    ],
  },
  {
    id: "gu-jing-shen",
    name: "顾景深",
    avatar:
      "https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20tall%20charismatic%20young%20chinese%20actor%20with%20calm%20gaze%2C%20soft%20neutral%20grey%20background%2C%20cinematic%20soft%20lighting%2C%20clean%20editorial%20photography%20style%2C%20highly%20detailed%2C%20no%20text&width=500&height=500&seq=actor-gujingshen&orientation=squarish",
    bio: "顾景深，演员、模特出身，身高 188cm。以科幻与奇幻题材作品广受关注，在《星尘之约》《山海幻梦录》中分别塑造了宇航员与守梦人两个反差极大的角色，展现出宽阔的戏路。",
    birthday: "1992-12-03",
    birthPlace: "北京",
    tags: ["大银幕", "科幻题材", "戏路宽阔"],
    works: [
      { dramaId: "xing-chen-zhi-yue", title: "星尘之约", role: "饰 陆星野（宇航员）", year: 2024 },
      { dramaId: "shan-hai-huan-meng-lu", title: "山海幻梦录", role: "饰 沈烬", year: 2024 },
      { dramaId: "shen-hai-deng-ta", title: "深海灯塔", role: "饰 方屿（深海工程师）", year: 2023 },
    ],
  },
  {
    id: "jiang-shu-tong",
    name: "江疏桐",
    avatar:
      "https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20sharp%20elegant%20young%20chinese%20businesswoman%20actress%2C%20soft%20neutral%20grey%20background%2C%20cinematic%20soft%20lighting%2C%20clean%20editorial%20photography%20style%2C%20highly%20detailed%2C%20no%20text&width=500&height=500&seq=actor-jiangshutong&orientation=squarish",
    bio: "江疏桐，演员，都市职场题材的代表面孔之一。她塑造的记者、投资人多干练而不失温度，台词功底扎实。近年逐渐从配角走向担纲主线，是备受期待的“熟脸实力派”。",
    birthday: "1994-02-25",
    birthPlace: "上海",
    tags: ["职场精英", "台词扎实", "都市剧常客"],
    works: [
      { dramaId: "mu-se-hui-sheng", title: "暮色回声", role: "饰 罗蔓（记者）", year: 2024 },
      { dramaId: "ni-liu-er-shang", title: "逆流而上", role: "饰 舒曼", year: 2024 },
    ],
  },
  {
    id: "cheng-yi-fan",
    name: "程亦凡",
    avatar:
      "https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20bright%20youthful%20young%20chinese%20actor%20with%20friendly%20smile%2C%20soft%20neutral%20beige%20background%2C%20cinematic%20soft%20lighting%2C%20clean%20editorial%20photography%20style%2C%20highly%20detailed%2C%20no%20text&width=500&height=500&seq=actor-chengyifan&orientation=squarish",
    bio: "程亦凡，1999 年生，青年演员，以青春、古装题材为观众所喜爱。在《追光者》中饰演吉他手周野，展现出不俗的音乐表现力；在《春风渡长安》中则演绎了沉稳内敛的少年少卿。",
    birthday: "1999-07-15",
    birthPlace: "广东广州",
    tags: ["新生代", "古装小生", "青春剧"],
    works: [
      { dramaId: "chun-feng-du-chang-an", title: "春风渡长安", role: "饰 裴砚", year: 2024 },
      { dramaId: "zhui-guang-zhe", title: "追光者", role: "饰 周野", year: 2024 },
    ],
  },
  {
    id: "bai-qing-ge",
    name: "白清歌",
    avatar:
      "https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20graceful%20young%20chinese%20actress%20with%20poised%20expression%2C%20soft%20neutral%20grey%20background%2C%20cinematic%20soft%20lighting%2C%20clean%20editorial%20photography%20style%2C%20highly%20detailed%2C%20no%20text&width=500&height=500&seq=actor-baiqingge&orientation=squarish",
    bio: "白清歌，演员，古装与现代题材双栖。她既能驾驭《春风渡长安》中灵动的画师，也能演出《玫瑰与荆棘》中锋芒毕露的女设计师。表演收放自如，气质清冷而富有辨识度。",
    birthday: "1996-11-08",
    birthPlace: "浙江杭州",
    tags: ["古装美人", "双栖演员", "气质出众"],
    works: [
      { dramaId: "mei-gui-yu-jing-ji", title: "玫瑰与荆棘", role: "饰 姜玫", year: 2024 },
      { dramaId: "shen-hai-deng-ta", title: "深海灯塔", role: "饰 陆昭（领航员）", year: 2023 },
      { dramaId: "chun-feng-du-chang-an", title: "春风渡长安", role: "饰 沈折枝", year: 2024 },
    ],
  },
  {
    id: "xu-nan-chuan",
    name: "许南川",
    avatar:
      "https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20steady%20mature%20young%20chinese%20actor%20with%20warm%20reliable%20look%2C%20soft%20neutral%20grey%20background%2C%20cinematic%20soft%20lighting%2C%20clean%20editorial%20photography%20style%2C%20highly%20detailed%2C%20no%20text&width=500&height=500&seq=actor-xunanchuan&orientation=squarish",
    bio: "许南川，演员，以年代剧与现实主义作品见长。他擅长塑造踏实、隐忍的普通人形象，《云上归途》中的父亲何长风与《铁道往事》中的铁路工郑铁生都给观众留下深刻印象。",
    birthday: "1988-03-30",
    birthPlace: "河北石家庄",
    tags: ["年代剧", "质朴表演", "现实主义"],
    works: [
      { dramaId: "yun-shang-gui-tu", title: "云上归途", role: "饰 何长风", year: 2023 },
      { dramaId: "tie-dao-wang-shi", title: "铁道往事", role: "饰 郑铁生", year: 2023 },
    ],
  },
  {
    id: "wen-yi-ning",
    name: "温以宁",
    avatar:
      "https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20smart%20intellectual%20young%20chinese%20actress%20with%20calm%20eyes%2C%20soft%20neutral%20beige%20background%2C%20cinematic%20soft%20lighting%2C%20clean%20editorial%20photography%20style%2C%20highly%20detailed%2C%20no%20text&width=500&height=500&seq=actor-wenyining&orientation=squarish",
    bio: "温以宁，演员，兼具理性气质与青春感。她在《星尘之约》中饰演天体物理学家林晚，在《追光者》中演绎主唱夏禾，从知识分子到热血青年皆能驾驭，是备受业内看好的多面手。",
    birthday: "1997-05-19",
    birthPlace: "湖北武汉",
    tags: ["多面手", "知识分子", "青春题材"],
    works: [
      { dramaId: "xing-chen-zhi-yue", title: "星尘之约", role: "饰 林晚（天体物理学家）", year: 2024 },
      { dramaId: "tie-dao-wang-shi", title: "铁道往事", role: "饰 白桦", year: 2023 },
      { dramaId: "zhui-guang-zhe", title: "追光者", role: "饰 夏禾", year: 2024 },
    ],
  },
  {
    id: "huo-yu-heng",
    name: "霍聿珩",
    avatar:
      "https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20sharp%20confident%20young%20chinese%20actor%20in%20dark%20suit%2C%20soft%20neutral%20grey%20background%2C%20cinematic%20soft%20lighting%2C%20clean%20editorial%20photography%20style%2C%20highly%20detailed%2C%20no%20text&width=500&height=500&seq=actor-huoyuheng&orientation=squarish",
    bio: "霍聿珩，演员，都市与职场题材中的高辨识度面孔。他塑造的投资人、少卿等角色冷峻而深情，气场十足。近年凭借《逆流而上》《玫瑰与荆棘》热度稳步上升。",
    birthday: "1991-10-11",
    birthPlace: "山东青岛",
    tags: ["都市精英", "气场强大", "热度上升"],
    works: [
      { dramaId: "mei-gui-yu-jing-ji", title: "玫瑰与荆棘", role: "饰 傅凛", year: 2024 },
      { dramaId: "ni-liu-er-shang", title: "逆流而上", role: "饰 谢知行", year: 2024 },
    ],
  },
];